var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paper",
    filter: "url(#filter0_d_871_2542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 44",
    filter: "url(#filter1_dd_871_2542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9933 30.0739C70.9933 30.0739 61.4087 29.5739 61.4087 38.3929C61.4087 38.3929 61.9965 49.6197 57.4938 84.4169C52.9911 119.214 41.0066 132.093 46.3781 132.288L112.179 134.682C112.391 128.87 115.117 117.614 119.341 85.6381C121.655 68.1267 121.994 56.4467 121.994 47.5739C121.994 31.0739 127.993 30.0739 127.993 30.0739L70.9933 30.0739Z",
    fill: "url(#paint0_linear_871_2542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9933 30.0739C70.9933 30.0739 61.4087 29.5739 61.4087 38.3929C61.4087 38.3929 61.9965 49.6197 57.4938 84.4169C52.9911 119.214 41.0066 132.093 46.3781 132.288L112.179 134.682C112.391 128.87 115.117 117.614 119.341 85.6381C121.655 68.1267 121.994 56.4467 121.994 47.5739C121.994 31.0739 127.993 30.0739 127.993 30.0739L70.9933 30.0739Z",
    fill: "url(#paint1_linear_871_2542)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 48",
    filter: "url(#filter2_f_871_2542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2366 95.5552C69.347 88.2226 61.152 88.7377 57.4157 89.9119C66.8373 89.452 68.6406 92.9427 69.5487 97.3093C70.2751 100.803 73.1531 103.417 74.5014 104.287L96.9362 104.233C102.321 104.219 103.666 103.779 107.253 102.897C110.841 102.014 109.934 98.0845 110.82 93.7136C111.53 90.2168 116.495 89.9134 118.888 90.1988L118.884 88.4513C117.987 88.4535 114.027 84.0943 110.797 84.1022C106.759 84.1121 107.657 84.5468 102.282 88.4918C99.6865 90.3971 97.3551 91.9989 92.428 95.506L77.6327 100.348C76.736 100.641 74.4048 101.492 72.2366 95.5552Z",
    fill: "url(#paint2_linear_871_2542)",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 57",
    filter: "url(#filter3_i_871_2542)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90.3354,
    cy: 62.2928,
    r: 13.7635,
    transform: "rotate(2.34983 90.3354 62.2928)",
    fill: "#FF8990"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.439 37.6513L122.287 41.8177L134.104 42.0544C134.407 42.1771 134.733 42.1877 135.092 42.0742C135.151 42.0556 135.211 42.0336 135.272 42.0082C134.102 41.7932 133.111 41.0696 132.535 40.0752C132.523 40.075 132.511 40.0746 132.5 40.0742C132.47 40.012 132.44 39.9328 132.409 39.8386C132.155 39.3239 132.009 38.7467 132 38.1364C131.862 37.4553 131.721 36.6842 131.586 35.9451C131.359 34.7084 131.149 33.5612 131 33.0742C130.416 31.1701 129 30.0742 128 30.0742C124.5 30.0742 122.563 34.2187 122.439 37.6513Z",
    fill: "#EB3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 131",
    d: "M140 38.0742C140 40.2834 138.209 42.0742 136 42.0742C133.791 42.0742 132 40.2834 132 38.0742C132 38.0742 133.791 38.0742 136 38.0742C138.209 38.0742 140 38.0742 140 38.0742Z",
    fill: "#FF8181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check",
    filter: "url(#filter4_d_871_2542)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 111",
    cx: 90,
    cy: 63,
    r: 18.75,
    fill: "url(#paint3_linear_871_2542)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 46 (Stroke)",
    filter: "url(#filter5_d_871_2542)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6537 57.9515C99.217 58.5148 99.217 59.428 98.6537 59.9912L89.3138 69.3311C88.4979 70.1471 87.175 70.1471 86.359 69.3311L81.346 64.3182C80.7828 63.7549 80.7828 62.8417 81.346 62.2784C81.9093 61.7152 82.8225 61.7152 83.3858 62.2784L86.7603 65.6529C87.3546 66.2473 88.3182 66.2473 88.9126 65.6529L96.614 57.9515C97.1773 57.3882 98.0905 57.3883 98.6537 57.9515Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463929",
    x: 60.1704,
    y: 92.7168,
    width: 54,
    height: 6,
    rx: 3,
    transform: "rotate(3 60.1704 92.7168)",
    fill: "#E1E6EE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463930",
    x: 57.605,
    y: 103.535,
    width: 54,
    height: 6,
    rx: 3,
    transform: "rotate(3 57.605 103.535)",
    fill: "#E1E6EE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463931",
    x: 55.3108,
    y: 114.354,
    width: 54,
    height: 6,
    rx: 3,
    transform: "rotate(3 55.3108 114.354)",
    fill: "#E1E6EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_871_2542",
    x: 24.8088,
    y: 25.0157,
    width: 135.402,
    height: 145.035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.1053
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.207843 0 0 0 0 0.258824 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_871_2542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_871_2542",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_871_2542",
    x: 37.4404,
    y: 27.542,
    width: 98.1319,
    height: 119.771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.05266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78949
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.704449 0 0 0 0 0.704449 0 0 0 0 0.704449 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_871_2542"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.314913 0 0 0 0 0.372035 0 0 0 0 0.404167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_871_2542",
    result: "effect2_dropShadow_871_2542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_871_2542",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_871_2542",
    x: 51.0998,
    y: 77.7857,
    width: 74.1043,
    height: 32.8172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.15791,
    result: "effect1_foregroundBlur_871_2542"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_871_2542",
    x: 75.3085,
    y: 48.5293,
    width: 28.7906,
    height: 28.7905,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.26316,
    dy: 1.26316
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89475
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.966949 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_871_2542"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_871_2542",
    x: 65.6089,
    y: 40.6795,
    width: 51.7821,
    height: 51.7821,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5,
    dy: 3.57053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.57053
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.90864 0 0 0 0 0.363456 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_871_2542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_871_2542",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_871_2542",
    x: 77.3531,
    y: 55.744,
    width: 25.2936,
    height: 19.5551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.78526
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.78526
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0283818 0 0 0 0 0.829026 0 0 0 0 0.348639 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_871_2542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_871_2542",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_871_2542",
    x1: 78.8127,
    y1: 8.9766,
    x2: 94.1807,
    y2: 107.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989603,
    stopColor: "#FF3939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_871_2542",
    x1: 121.994,
    y1: 50.574,
    x2: 114.994,
    y2: 50.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_871_2542",
    x1: 83.924,
    y1: 104.264,
    x2: 84.3239,
    y2: 93.7772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFABAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_871_2542",
    x1: 101.321,
    y1: 74.5927,
    x2: 79.6886,
    y2: 45.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24C791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF7EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.8b6cf12f40d870296b5fe0a8cdf45afa.svg";
export { ForwardRef as ReactComponent };